import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { normalize } from '../../../helpers/pagination';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  articles: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_ARTICLES_BUSY: (state, payload) => {
    state.articles.isBusy = payload;
  },
  LOAD_ARTICLES_SUCCESS: (state, payload) => {
    state.articles.data = payload.data;
    state.articles.error = null;
  },
  LOAD_ARTICLES_FAIL: (state, payload) => {
    state.articles.data = null;
    state.articles.error = payload;
  }
};

const actions = {
  getArticles: ({ commit, rootState }, { projectId, filterValues, pagination }) => {
    commit('LOAD_ARTICLES_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    let query = '';
    if (pagination && Object.keys(pagination).length > 0) {
      query = '?';
      const normalized = normalize(pagination);
      Object.keys(normalized).map((param, i) => {
        let paramName = param;
        if(paramName === 'current_page') {
          paramName = 'page';
        }
        query += `${paramName}=${normalized[param]}${i !== Object.keys(normalized).length - 1 ? '&' : ''}`;
      });
    }
    Axios
      .post(`${API_HOST}/projects/${projectId}/queries/article_list${query}`, filterValues, config)
      .then(response => {
        commit('LOAD_ARTICLES_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_ARTICLES_FAIL', error)
      })
      .finally(() => commit('LOAD_ARTICLES_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};